<div class="SAS_Navbar">
  <!-- Header -->
  <app-outer-pages-header></app-outer-pages-header>

  <section class="about-jtc top-background no-printme">
    <div class="background-image">
      <div class="container">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb custom-breadcrumb">
            <li class="breadcrumb-item">
              <a [routerLink]="['/']">الرئيسية</a>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              خدمة مستشارك في التخاطب
            </li>
          </ol>
        </nav>
        <h1 class="sub-title">خدمة مستشارك في التخاطب</h1>
      </div>
    </div>
  </section>

  <div class="intro2">
    <!-- <div class="container">
      <div class="row">
        <h3
          class="col-lg-5 col-sm-12 text-center heading-title mb-4 pt-4 text-site-color"
        >
          خدمة مستشارك في التخاطب :
        </h3>

        <div class="col-lg-7 col-sm-12 row text-white justify-content-around">
          <div
            class="service bg-site-color pt-3 px-3 pointer hvr-wobble-bottom"
            style="border-radius: 0 0 5px 5px"
            [routerLink]="['/Sas/ConsultantPlatform']"
          >
            <h3 class="text-center font-size-22 mb-0">احجز الآن</h3>
            <div class="icon-container flex justfy-center">
              <i class="fas fa-check-square fa-5x icon-rounded"></i>
            </div>
          </div>
        </div>
      </div>
    </div> -->

    <!-- <div class="container">
      <div class="row">
        <div class="col-md-4 col-sm-12">
          <h4 class="sub-title">خدمة مستشارك في التخاطب</h4>
        </div>
        <div class="col-md-8 col-sm-12">
          <button class="btn bg-site-color" [routerLink]="['/Sas/ConsultantPlatform']" style="margin-top: 25px;border: none;"> احجز الآن</button>
        </div>
      </div>
    </div> -->

    <div class="container">
      <div class="WhoAreWe consultant">
        <div class="section-title">
          <h2>خدمة مستشارك في التخاطب :</h2>
        </div>

        <div class="row g-24">
          <!-- <div class="col-lg-4">
            <img
              src=".././../../assets/images/WhoWeAre.jpg"
              class="img-fluid img-thumbnail-edit"
            />
          </div> -->

          <div class="col-lg-8">
            <div class="consultant-content">
              <p>
                يتوافر لدينا نخبة من الاخصائييين والاستشاريين المتميزين في مجال
                أمراض التخاطب والسمع من جنسيات مختلفة لتقديم خدمة مستشارك في
                التخاطب عبر موقعنا الاليكتروني أو من خلال تطبيق الجوال .
              </p>
              <p>
                ويقوم المختص كل حسب تخصصه وخبرته المتميزة في تشخيص وعلاج ومتابعة
                اضطرابات التخاطب والسمع (مثل اضطرابات النطق، اضطرابات اللغة،
                اضطرابات الصوت، اضطرابات التلعثم، فرط الحركة وقصور الانتباه،
                متلازمة داون، التوحد، العي، زراعة القوقعة الخ) .
              </p>
              <p>
                يمكنك طلب خدمة مستشارك في التخاطب من خلال حجز موعد مع أحد
                <a
                  [routerLink]="['/Sas/ConsultantPlatform']"
                  class="text-site-color"
                  >(الاخصائيين او الاستشاريين العاملين معنا)</a
                >
                ، وستكون وسيلة التواصل مع المختص عبر
                <a [routerLink]="['/']" class="text-site-color"
                  >(موقعنا الاليكتروني)</a
                >
                , أو من خلال تطبيق الجوال
                <a href="#" target="_blank" class="text-site-color"
                  >(اضغط هنا لتحميل التطبيق)</a
                >
                .
              </p>
            </div>
            <a
              class="btn btn-primary mt-4"
              [routerLink]="['/Sas/ConsultantPlatform']"
              >احجز الآن</a
            >
          </div>
          <div class="col-lg-4">
            <img
              src=".././../../assets/images/banner4.jpg"
              class="img-fluid img-thumbnail-edit"
            />
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Footer -->
  <app-outer-pages-footer></app-outer-pages-footer>
</div>
